export default "__VITE_ASSET__DWf8koUV__"